module.exports = __webpack_public_path__ + "img/Logo_Peak1.7d6d614e.svg";